import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    getBuilds({ commit }, value) {
      commit("getBuilds", value);
    },
    getNews({ commit }, value) {
      commit("getNews", value);
    },
    themeSwitch({ commit }, value) {
      commit("themeSwitch", value);
    },
  },
  mutations: {
    getBuilds(state, value) {
      state.builds = value;
    },
    getNews(state, value) {
      state.news = value;
    },
    themeSwitch(state, value) {
      state.theme = value;
    },
  },
  state: {
    apiSpace: process.env.VUE_APP_CONTENTFUL_SPACE,
    apiToken: process.env.VUE_APP_CONTENTFUL_ACCESSTOKEN,
    IGSecret: process.env.VUE_APP_IG_SECRET,
    IGToken: process.env.VUE_APP_IG_ACCESSTOKEN,
    builds: [],
    news: [],
    theme: "light",
  },
});
